import { render, staticRenderFns } from "./OptionSettingsPagamentos.vue?vue&type=template&id=59c8c312&scoped=true&"
import script from "./OptionSettingsPagamentos.vue?vue&type=script&lang=js&"
export * from "./OptionSettingsPagamentos.vue?vue&type=script&lang=js&"
import style0 from "./OptionSettingsPagamentos.vue?vue&type=style&index=0&id=59c8c312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8c312",
  null
  
)

export default component.exports